import { AddOrEditDeploymentTargetPage } from "./AddOrEditDeploymentTargetPage";
interface DeploymentTargetSettingsPageProps {
    spaceId: string;
    machineId: string;
}
export function DeploymentTargetSettingsPage({ spaceId, machineId }: DeploymentTargetSettingsPageProps) {
    return <AddOrEditDeploymentTargetPage spaceId={spaceId} machineId={machineId}/>;
}
